<template>
  <div>
    <BaseSelect
      v-model="target[type]"
      placeholder="Søg"
      tag-position="bottom"
      :options="getAllPreparations"
      track-by="name"
      label="name"
      :multiple="false"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import BaseSelect from '../../../components/BaseSelect.vue';

export default {
    name: 'TargetPreparation',
    components: { BaseSelect },
    props: {
        target: { type: Object, required: true },
        type: { type: String, required: true },
    },
    computed: {
        ...mapGetters('preparations', [
            'getAllPreparations',
        ]),
    },
    methods: {
        ...mapActions('preparations', [
            'loadPreparations',
        ]),
    },
    async created() {
        try {
            await this.loadPreparations();
        } catch (error) {
            //
        }
    },
};
</script>
